export interface CommonDataState {
    showQuickGuide: boolean;
}

export const initialState: CommonDataState = {
    showQuickGuide: false,
};
